<script>
import ModalWrapper from "@/components/modals/ModalWrapper";
import PrimaryButton from "@/components/PrimaryButton";

export default {
  name: "RealityGlyphCreationModal",
  components: {
    ModalWrapper,
    PrimaryButton
  },
  data() {
    return {
      isDoomed: false,
      realityGlyphLevel: 0,
      // This contains an array where each entry is an array looking like [4000, "realitygalaxies"]
      possibleEffects: [],
    };
  },
  methods: {
    update() {
      this.isDoomed = Pelle.isDoomed;
      this.realityGlyphLevel = AlchemyResource.reality.effectValue;
      const realityEffectConfigs = GlyphEffects.all
        .filter(eff => eff.glyphTypes.includes("reality"))
        .sort((a, b) => a.bitmaskIndex - b.bitmaskIndex);
      const minRealityEffectIndex = realityEffectConfigs.map(cfg => cfg.bitmaskIndex).min();
      this.possibleEffects = realityEffectConfigs
        .map(cfg => [realityGlyphEffectLevelThresholds[cfg.bitmaskIndex - minRealityEffectIndex], cfg.id]);
    },
    createRealityGlyph() {
      if (GameCache.glyphInventorySpace.value === 0) {
        Modal.message.show("Нет доступного места в инвентаре; Пожертвуйте некоторые Глифы, чтобы освободить место.",
          { closeEvent: GAME_EVENT.GLYPHS_CHANGED });
        return;
      }
      Glyphs.addToInventory(GlyphGenerator.realityGlyph(this.realityGlyphLevel));
      AlchemyResource.reality.amount = 0;
      player.reality.glyphs.createdRealityGlyph = true;
      this.emitClose();
    },
    formatGlyphEffect(effect) {
      if (this.realityGlyphLevel < effect[0]) return `(Требует ${formatInt(effect[0])} уровень Глифа)`;
      const config = GlyphEffects[effect[1]];
      const value = config.effect(this.realityGlyphLevel, rarityToStrength(100));
      const effectTemplate = config.singleDesc;
      return effectTemplate.replace("{value}", config.formatEffect(value));
    }
  },
};
</script>

<template>
  <ModalWrapper>
    <template #header>
      Создание Глифа Реальности
    </template>
    <div class="c-reality-glyph-creation">
      <div>
        Создать Глиф Реальности {{ formatInt(realityGlyphLevel) }} уровня.
        Редкость всегда будет {{ formatPercents(1) }}, а
        уровень меняется в зависимости от текущего Ресурса Реальности (а он весь использован). Все другие Алхимические
        Ресурсы будут нетронуты. Глифы Реальности имеют уникальные эффекты, некоторые из которых доступны только в
        Глифах более высокого уровня. Глифы Реальности также могут быть жертвованы для повышения заработка всех Кусков
        Памяти. также, как и Глифы Эффарига, вы не можете экипировать более одного за раз.
      </div>
      <div class="o-available-effects-container">
        <div class="o-available-effects">
          Доступные эффекты:
        </div>
        <div
          v-for="(effect, index) in possibleEffects"
          :key="index"
        >
          {{ formatGlyphEffect(effect) }}
        </div>
      </div>
      <PrimaryButton
        v-if="isDoomed"
        :enabled="false"
      >
        Вы не можете создавать Глифы Реальности пока Обречены
      </PrimaryButton>
      <PrimaryButton
        v-else-if="realityGlyphLevel !== 0"
        @click="createRealityGlyph"
      >
        Создать Глиф Реальности!
      </PrimaryButton>
      <PrimaryButton
        v-else
        :enabled="false"
      >
        Уровень Глифа Реальности должен быть больше чем {{ formatInt(0) }}
      </PrimaryButton>
    </div>
  </ModalWrapper>
</template>

<style scoped>
.o-available-effects-container {
  margin: 1.5rem 0 2rem;
}

.o-available-effects {
  font-weight: bold;
}
</style>
